<template>
  <div class="page_openPlatform">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">

        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>开放平台</el-breadcrumb-item>
          <el-breadcrumb-item>项目定制数据</el-breadcrumb-item>
          <el-breadcrumb-item>定制详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">

        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addField">新增字段</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
          <el-table-column key="0" label="序号" min-width="100" align="center">
            <template slot-scope="{$index}">{{ (listQuery.PageModel.Page - 1) * listQuery.PageModel.Rows + $index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="fieldName" key="1" label="字段名称" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fieldLab" key="2" label="字段显示" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="inputMethod" key="4" label="获取方式" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.inputMethod =='1' ? '前端输入' : '单选'}}</template>
          </el-table-column>
          <el-table-column prop="caseInter" key="5" label="适用接口" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="remark" key="6" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandel(row)">编辑</el-button>
                <el-popconfirm title="请确定是否删除" @confirm="del(row)">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增对接-->
    <el-dialog :title="type=='add' ? '新增字段' : '修改'" :visible.sync="addFieldVisible" width="900px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="statementForm" :inline="true" :model="fieldForm" class="" label-width="100px" size="small">
        <el-form-item label="字段名称" prop="fieldName">
          <el-input v-model="fieldForm.fieldName" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="字段显示" prop="fieldLab">
          <el-input v-model="fieldForm.fieldLab" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="获取方式" prop="inputMethod">
          <el-select v-model="fieldForm.inputMethod" placeholder="" clearable filterable style="width:300px">
            <el-option label="前端输入" value="1"></el-option>
            <el-option label="单选" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可选项" v-if="fieldForm.inputMethod=='2'">
          <el-input v-model="fieldForm.inputTip" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item :label="fieldForm.inputMethod=='1' ? '输入提示' : '选择提示'">
          <el-input v-model="fieldForm.inputTip" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="字段长度">
          <el-input v-model="fieldForm.fieldLength" type="number" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="适用接口" prop="name">
          <el-select v-model="appInter" placeholder="" multiple clearable filterable style="width:300px">
            <el-option v-for="(item,index) in interfaceList" :key="index" :label="item.fileName" :value="item.fileName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="fieldLab">
          <el-input v-model="fieldForm.remark" size="small" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFieldVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmaddField" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    create,
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          projectSetId: '',
        },
        needLoading: false,
        fieldForm: {
          id: '',
          fieldName: '', //字段名称
          fieldLab: '', //字段显示
          remark: '',
          inputMethod: '', //输入方法1为输入，2为单选
          inputTip: '', //输入提示
          selectVal: '', //单选值
          caseInter: '',
          caseInterDic: [],
          fieldLength: 20,
          projectSetId: ''
        },
        appInter: [],
        type: '',
        fileList: [],
        addFieldVisible: false,
        isbtnLoading: false,
        activeName: '0',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        permissionLists: [],
        rules: {},
        interfaceList: [], //适用接口列表
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.listQuery.projectSetId = this.$route.query.id
        this.getList();
      }
      this.GetSocialSecurityFundPageList();
      // this.getButtonPower();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      //获取适用接口列表
      GetSocialSecurityFundPageList() {
        let d = {
          PageModel: {
            Rows: 1000,
            Page: 1,
            OrderInput: []
          },
          fileName: '',
          busiType: 3,
          busiId: ''
        }
        xz.ArdCurStat(d, 'GetSocialSecurityFundPageList').then(res => {
          if (res.status == 'ok') {
            this.interfaceList = res.data.data;
          } else {
            this.interfaceList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetCustomFieldList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      changePro(val) {},
      //新增
      addField() {
        this.fieldForm = {
          id: '',
          fieldName: '',
          fieldLab: '',
          remark: '',
          inputMethod: '',
          inputTip: '',
          selectVal: '',
          caseInter: '',
          fieldLength: 20,
          caseInterDic: [],
          projectSetId: this.listQuery.projectSetId
        }
        this.type = 'add';
        this.isbtnLoading = false;
        this.addFieldVisible = true;
      },
      editHandel(row) {
        this.type = 'edit';
        this.fieldForm = {
          id: row.id,
          fieldName: row.fieldName,
          fieldLab: row.fieldLab,
          remark: row.remark,
          inputMethod: row.inputMethod,
          inputTip: row.inputTip,
          selectVal: row.selectVal,
          caseInter: row.caseInter,
          fieldLength: row.fieldLength,
          caseInterDic: [],
          projectSetId: this.listQuery.projectSetId
        }
        this.appInter = row.caseInter.split(',');
        this.type = 'edit';
        this.isbtnLoading = false;
        this.addFieldVisible = true;
      },
      confirmaddField() {
        this.isbtnLoading = true;
        this.appInter.forEach(ele => {
          let item = this.interfaceList.find(e => ele == e.fileName);
          let d = {
            id: item.id,
            val: item.fileName
          }
          this.fieldForm.caseInterDic.push(d)
        });
        xz.ArdCurStat(this.fieldForm, 'AddUpdataDellCustomField').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功')
            this.getList();
            this.addFieldVisible = false;
            this.isbtnLoading = false;
          } else {
            this.$message.error(res.msg)
            this.isbtnLoading = false;
          }
        })
      },
      //作废
      del(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataDellMerchantDocking').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.addFieldVisible = false;
            this.$message.success("作废成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }
</style>
<style>
  .page_openPlatform .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_openPlatform .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_openPlatform .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_openPlatform .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_openPlatform .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_openPlatform .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>